import { render, staticRenderFns } from "./Card-Product.vue?vue&type=template&id=5f24c406&"
import script from "./Card-Product.vue?vue&type=script&lang=js&"
export * from "./Card-Product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports